import { z } from 'zod'
import { fileUpload } from '~/services/api/contracts/fileUpload'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { UpdateMenuItemRequestSchema } from '~/services/api/generated'
import { menuItemFieldsNormalizer } from '~/services/api/contracts/normalizers/menuItemFieldsNormalizer'

const PHOTO = { mimes: ['jpeg', 'jpg', 'png', 'webp'], maxKb: 5120 } as const

const hasAtMostTwoDecimals = (value: number): boolean =>
  Math.abs(value * 100 - Math.round(value * 100)) < 1e-9

const schema = UpdateMenuItemRequestSchema.extend({ photo: fileUpload(PHOTO).optional() }).strict()

export const MenuItemUpdate = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(menuItemFieldsNormalizer, schema).superRefine((value, issues) => {
    if (
      'price_type' in value &&
      value.price_type === 'group_tray' &&
      (value.serves_count === undefined || value.serves_count === null)
    ) {
      issues.addIssue({
        code: 'custom',
        message: 'The serves count field is required when price type is group_tray',
        path: ['serves_count']
      })
    }
    if (value.default_price !== undefined && !hasAtMostTwoDecimals(value.default_price)) {
      issues.addIssue({
        code: 'custom',
        message: 'The default price field must have 0-2 decimal places',
        path: ['default_price']
      })
    }
  })
